import { createSlice } from "@reduxjs/toolkit";


let initialState = {
    selectedEmpsForTimeSheetApprove :[],
    user:{}
    
}


const WorkHubAppSlice = createSlice({
    name:'WorkHubAppSlice',
    initialState,
    reducers:{
        setSelectedEmpsForTimeSheetApprove : (state , action)=>{
            state.selectedEmpsForTimeSheetApprove = action?.payload
        },
        setLoggedinUser:(state , action)=>{
            state.user= action.payload
        },
        /* The header reads the photo from here, so changing it on the profile
           page shows up in the top bar without another round trip. */
        setProfilePic:(state , action)=>{
            if(state.user && state.user.employee){
                state.user.employee.profilePic = action.payload
            }
        }
    }
})

export const {setSelectedEmpsForTimeSheetApprove , setLoggedinUser, setProfilePic}=WorkHubAppSlice.actions
export default WorkHubAppSlice.reducer